import React from 'react';
import { Button } from './Button';
import { WalletIcon } from './WalletIcon';
export var WalletListItem = function WalletListItem(_ref) {
  var handleClick = _ref.handleClick,
      tabIndex = _ref.tabIndex,
      wallet = _ref.wallet;
  return React.createElement("li", null, React.createElement(Button, {
    onClick: handleClick,
    endIcon: React.createElement(WalletIcon, {
      wallet: wallet
    }),
    tabIndex: tabIndex
  }, wallet.name));
};